module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-ni.3276d382.png";